"use client"

import React, { useEffect } from 'react'
import { useConfirmationDialog } from '@/components/ui/confirmation-dialog'
import { registerConfirmDialogHandler, type ConfirmOptions } from '@/app/utils/confirmDialog'

interface ConfirmDialogProviderProps {
  children: React.ReactNode
}

export function ConfirmDialogProvider({ children }: ConfirmDialogProviderProps) {
  const { showConfirmation, ConfirmationDialog } = useConfirmationDialog()

  useEffect(() => {
    // Register the global dialog handler
    registerConfirmDialogHandler((options: ConfirmOptions & { 
      onConfirm: () => void | Promise<void>
      onCancel?: () => void
    }) => {
      showConfirmation({
        title: options.title,
        message: options.message,
        confirmText: options.confirmText,
        cancelText: options.cancelText,
        variant: options.variant,
        onConfirm: options.onConfirm,
        onCancel: options.onCancel,
      })
    })

    // Cleanup on unmount
    return () => {
      registerConfirmDialogHandler(null)
    }
  }, [showConfirmation])

  return (
    <>
      {children}
      <ConfirmationDialog />
    </>
  )
}